import {css} from "@pandacss/css";
import {createPandaComponent} from "../helpers/pandaComponent.ts";
import {FC} from "react";
import {DefaultProps} from "../helpers/defaultProps.tsx";

const contentAreaClass = css({
    width: "100%",
    maxWidth: "1024px",
    display: "flex",
    flexDirection: "column",
    gap: "20px",
    flexGrow: 1,
})

const contentAreaOuterClass = css({
    width: "100%",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    padding: "20px",
    flexGrow: 1,
})

const ContentAreaInner = createPandaComponent('ContentArea', 'div', [contentAreaClass]);
const ContentAreaOuter = createPandaComponent('ContentAreaOuter', 'div', [contentAreaOuterClass]);

const ContentArea: FC<DefaultProps> = ({ children }) => {
    return (
        <ContentAreaOuter>
            <ContentAreaInner>
                {children}
            </ContentAreaInner>
        </ContentAreaOuter>
    );
}

export default ContentArea;